import React from 'react';
import { Helmet } from 'react-helmet-async';
import { HelmetProvider } from 'react-helmet-async';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { WhyChooseUs } from './components/WhyChooseUs';
import { HowItWorks } from './components/HowItWorks';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <HelmetProvider data-id="element-0">
      <Helmet data-id="element-1">
        <title data-id="element-2">
          新加坡爽吧 Shiok8 | 新加坡按摩推荐平台 | 推拿SPA精油按摩预约 |
          自2003年
        </title>
        <meta name="description" content="新加坡爽吧(Shiok8)是新加坡历史最悠久的专业按摩推荐平台(Est.2003)，50,000+注册用户，2,000+认证技师。提供传统中式推拿、泰式按摩、精油SPA、足底按摩、肩颈理疗、深层组织按摩等服务。覆盖芽笼、乌节路、牛车水、武吉士等全岛各区，支持上门按摩与到店预约。严格技师审核，真实用户评价，智能匹配推荐。Singapore's most trusted massage recommendation platform since 2003." data-id="element-3" />
        <meta name="keywords" content="新加坡按摩, 新加坡推拿, 新加坡SPA, 新加坡精油按摩, 按摩推荐, 按摩预约, 上门按摩, 到店按摩, 中式推拿, 泰式按摩, 足底按摩, 肩颈按摩, 全身按摩, 深层组织按摩, 芽笼按摩, 乌节路按摩, 牛车水按摩, 武吉士按摩, 专业技师, 认证按摩师, 养生保健, 减压放松, 亚健康调理, Shiok8, 新加坡爽吧, Singapore massage, massage recommendation, Chinese Tuina, Thai massage, essential oil spa, foot reflexology, Singapore wellness, massage booking" data-id="element-4" />
        <meta name="author" content="新加坡爽吧 Shiok8" data-id="element-5" />
        <meta name="robots" content="index, follow" data-id="element-6" />
        <link rel="canonical" href="https://geylang777-6.site/" data-id="element-7" />
        <meta httpEquiv="content-language" content="zh-CN, en" data-id="element-8" />

        {/* Open Graph */}
        <meta property="og:type" content="website" data-id="element-9" />
        <meta property="og:title" content="新加坡爽吧 Shiok8 | 新加坡按摩推荐·推拿·SPA·精油按摩预约平台" data-id="element-10" />
        <meta property="og:description" content="自2003年成立，新加坡最受信赖的按摩推荐平台。50,000+用户，2,000+认证技师，提供中式推拿、泰式按摩、精油SPA、足底按摩、肩颈理疗等专业服务，覆盖全岛各区。" data-id="element-11" />
        <meta property="og:url" content="https://geylang777-6.site/" data-id="element-12" />
        <meta property="og:site_name" content="新加坡爽吧 Shiok8" data-id="element-13" />
        <meta property="og:locale" content="zh_CN" data-id="element-14" />
        <meta property="og:locale:alternate" content="en_SG" data-id="element-15" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-16" />
        <meta name="twitter:title" content="新加坡爽吧 Shiok8 | 新加坡按摩推荐·推拿·SPA预约平台" data-id="element-17" />
        <meta name="twitter:description" content="新加坡历史最悠久的按摩推荐平台(2003年成立)，提供中式推拿、泰式按摩、精油SPA、足底按摩等服务，50,000+用户信赖之选。" data-id="element-18" />
      </Helmet>

      <div className="min-h-screen bg-[#FDF8F0] font-sans text-[#1A1A1A]" data-id="element-19">
        <Navbar data-id="element-20" />
        <main data-id="element-21">
          <HeroSection data-id="element-22" />
          <StatsBar data-id="element-23" />
          <AboutSection data-id="element-24" />
          <ServicesSection data-id="element-25" />
          <WhyChooseUs data-id="element-26" />
          <HowItWorks data-id="element-27" />
          <TestimonialsSection data-id="element-28" />
          <CTASection data-id="element-29" />
        </main>
        <Footer data-id="element-30" />
      </div>
    </HelmetProvider>;
}